/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.authViewAll'

export { $nsid }

const main = l.permissionSet(
  $nsid,
  [
    l.permission('rpc', {
      inheritAud: true,
      lxm: [
        'app.bsky.actor.getPreferences',
        'app.bsky.actor.getProfile',
        'app.bsky.actor.getProfiles',
        'app.bsky.actor.getSuggestions',
        'app.bsky.actor.searchActors',
        'app.bsky.actor.searchActorsTypeahead',
        'app.bsky.bookmark.getBookmarks',
        'app.bsky.feed.describeFeedGenerator',
        'app.bsky.feed.getActorFeeds',
        'app.bsky.feed.getActorLikes',
        'app.bsky.feed.getAuthorFeed',
        'app.bsky.feed.getFeed',
        'app.bsky.feed.getFeedGenerator',
        'app.bsky.feed.getFeedGenerators',
        'app.bsky.feed.getFeedSkeleton',
        'app.bsky.feed.getLikes',
        'app.bsky.feed.getListFeed',
        'app.bsky.feed.getPostThread',
        'app.bsky.feed.getPosts',
        'app.bsky.feed.getQuotes',
        'app.bsky.feed.getRepostedBy',
        'app.bsky.feed.getSuggestedFeeds',
        'app.bsky.feed.getTimeline',
        'app.bsky.feed.searchPosts',
        'app.bsky.graph.getActorStarterPacks',
        'app.bsky.graph.getBlocks',
        'app.bsky.graph.getFollowers',
        'app.bsky.graph.getFollows',
        'app.bsky.graph.getKnownFollowers',
        'app.bsky.graph.getListBlocks',
        'app.bsky.graph.getListMutes',
        'app.bsky.graph.getLists',
        'app.bsky.graph.getListsWithMembership',
        'app.bsky.graph.getMutes',
        'app.bsky.graph.getRelationships',
        'app.bsky.graph.getStarterPack',
        'app.bsky.graph.getStarterPacks',
        'app.bsky.graph.getStarterPacksWithMembership',
        'app.bsky.graph.getSuggestedFollowsByActor',
        'app.bsky.graph.searchStarterPacks',
        'app.bsky.labeler.getServices',
        'app.bsky.notification.getPreferences',
        'app.bsky.notification.getUnreadCount',
        'app.bsky.notification.listActivitySubscriptions',
        'app.bsky.notification.listNotifications',
        'app.bsky.notification.updateSeen',
        'app.bsky.unspecced.getAgeAssuranceState',
        'app.bsky.unspecced.getConfig',
        'app.bsky.unspecced.getOnboardingSuggestedStarterPacks',
        'app.bsky.unspecced.getPopularFeedGenerators',
        'app.bsky.unspecced.getPostThreadOtherV2',
        'app.bsky.unspecced.getPostThreadV2',
        'app.bsky.unspecced.getSuggestedFeeds',
        'app.bsky.unspecced.getSuggestedFeedsSkeleton',
        'app.bsky.unspecced.getSuggestedStarterPacks',
        'app.bsky.unspecced.getSuggestedStarterPacksSkeleton',
        'app.bsky.unspecced.getSuggestedUsers',
        'app.bsky.unspecced.getSuggestedUsersSkeleton',
        'app.bsky.unspecced.getSuggestionsSkeleton',
        'app.bsky.unspecced.getTaggedSuggestions',
        'app.bsky.unspecced.getTrendingTopics',
        'app.bsky.unspecced.getTrends',
        'app.bsky.unspecced.getTrendsSkeleton',
        'app.bsky.unspecced.searchActorsSkeleton',
        'app.bsky.unspecced.searchPostsSkeleton',
        'app.bsky.unspecced.searchStarterPacksSkeleton',
        'app.bsky.video.getUploadLimits',
      ],
    }),
  ],
  {
    title: 'Read-only access to all content',
    'title:lang': {},
    detail:
      'View Bluesky network content from account perspective, and read all notifications and preferences.',
    'detail:lang': {},
  },
)

export { main }
